// React
import React from 'react';
import { AppBar, Button, ButtonGroup, Toolbar } from '@material-ui/core';
// componentes
import { useStyles } from "./style";

export default function ComponenteToolbar (props) {
    const classes = useStyles();
    
    return (
        <div className={classes.root}>
            <AppBar position="static" className={classes.appBar} elevation={0}>
                <Toolbar >
                    {/* <TextField id="outlined-basic" margin="dense" label="CUI" variant="outlined" className={classes.menuButton}/>
                    <Button className={classes.buttonUpdate} onClick={props?.buttonFunctionUpdate} startIcon={props.buttonIconUpdate} variant="outlined">{props.buttonTitleUpdate}</Button>
                    <Typography className={classes.title} variant="subtitle1" >{props.titleGeneral}</Typography> */}
                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                        <Button className={classes.buttonUpdate} onClick={props?.buttonFunctionCreate} startIcon={props.buttonIconCreate} variant="outlined">{props.buttonTitleCreate}</Button>
                        {/* <Button className={classes.buttonUpdate} onClick={props?.buttonFunctionReport} startIcon={props.buttonIconReport} variant="outlined">{props.buttonTitleReport}</Button> */}
                        <Button className={classes.buttonUpdate} onClick={props?.buttonFunctionUpdate} startIcon={props.buttonIconUpdate} variant="outlined">{props.buttonTitleUpdate}</Button>
                    </ButtonGroup>
                </Toolbar>
            </AppBar>   
        </div>
    )
}